import React from 'react'
import config from '../config/config'
import { useTranslation } from 'react-i18next'

const BottomImage = ({ name }) => {
  const { i18n } = useTranslation()
  const imageConfig = config.bottomImages[name]

  if (!imageConfig) return null

  const { photoId, labelFr, labelEn, labelEs } = imageConfig

  const translatedLabel =
    i18n.language === 'fr'
      ? labelFr
      : i18n.language === 'es'
      ? labelEs
      : labelEn

  return (
    <div className="text-center mt-5">
      <img
        className="img-fluid rounded"
        src={`/images/photos/${photoId}.jpg`}
        alt={translatedLabel}
      />
      <p className="text-muted mt-2 fst-italic">{translatedLabel}</p>
    </div>
  )
}

export default BottomImage
